import { React, useEffect, useState } from "react";
import AdminDashboardLayout from "../../layout/AdminDashboardLayout";
import { DashboardWrapper } from "../dashboard/dashboard.styled";
import { IntroductionHeader } from "../dashboard/Dashboard";
import UserCharts from "./partials/UserCharts";
import { userHeaderCells } from "./data";
import UsersTable from "./partials/UsersTable";
import { getAllAdmins } from "./utils";
import { toast } from "react-toastify";
import { getFilteredTableData } from "../../utils/Utils";
import { useDispatch } from "react-redux";
import { setLoadingState } from "../../redux/AppSlice";

function UsersPage() {
	const dispatch = useDispatch();
	const [tableData, setTableData] = useState([]);
	const [defaultData, setDefaultData] = useState(); //this is default search functionality state
	const [dateFilter, setDateFilter] = useState("6 Months");
	const [filteredData, setFilteredData] = useState([]);

	useEffect(() => {
		handleDateFilterChange({ target: { value: dateFilter } });
	}, [tableData]);

	useEffect(() => {
		adminData();
	}, []);

	const adminData = async () => {
		dispatch(setLoadingState(true));
		try {
			const data = await getAllAdmins();
			if (data.result) {
				setTableData(data.result);
				console.log(data.result);
				setDefaultData(data.result);
				dispatch(setLoadingState(false));
			} else {
				toast.error("error fetching admin data!");
				dispatch(setLoadingState(false));
			}
		} catch (error) {
			console.error(error);
			toast.error("error fetching admin data!");
			dispatch(setLoadingState(false));
		}
	};

	const handleDateFilterChange = (e) => {
		// Filter TableData based on date - All Time, Today, Last 7 days, Last 30 days, Last 6 months, Last 12 months
		let filteredTableData = getFilteredTableData(e.target.value, tableData);
		setDateFilter(e.target.value);
		setFilteredData(filteredTableData);
	};

	return (
		<AdminDashboardLayout
			data={tableData}
			defaultData={defaultData}
			setData={setTableData}
		>
			<DashboardWrapper>
				<IntroductionHeader />
				<UserCharts />
				<UsersTable
					headCells={userHeaderCells}
					TableData={filteredData}
					allData={adminData}
					dateFilter={dateFilter}
					handleDateFilterChange={handleDateFilterChange}
				/>
			</DashboardWrapper>
		</AdminDashboardLayout>
	);
}

export default UsersPage;
